var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6D3E166Da482B6F5D4D33C5D5B362Da7D2C7Cdaa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 255.004 62.6706",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 3",
    filter: "url(#filter0_f_2007_747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3353 31.3353H223.669",
    stroke: "url(#paint0_linear_2007_747)",
    strokeWidth: 15.1274,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M31.3353 31.3353H223.669",
    stroke: "url(#paint1_linear_2007_747)",
    strokeWidth: 3.24158,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2007_747",
    x: 9.53674e-7,
    y: 9.53674e-7,
    width: 255.004,
    height: 62.6706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.8858,
    result: "effect1_foregroundBlur_2007_747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2007_747",
    x1: 31.3353,
    y1: 31.8353,
    x2: 223.669,
    y2: 31.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#00FF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF72",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2007_747",
    x1: 31.3353,
    y1: 31.8353,
    x2: 223.669,
    y2: 31.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#00FF72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF72",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6D3E166Da482B6F5D4D33C5D5B362Da7D2C7Cdaa);
export default __webpack_public_path__ + "static/media/6d3e166da482b6f5d4d33c5d5b362da7d2c7cdaa.2304c8caaa8021253cd41fd20b219003.svg";
export { ForwardRef as ReactComponent };